export default __webpack_public_path__ + "static/media/feather.ead41928.svg";